export default [
  {
    path: '/admin/trader/indicators',
    name: 'Indicators',
    component: () => import('@/views/Admin/Trader/Indicators/Index.vue'),
    meta: {
      pageTitle: 'İndikatörler',
      breadcrumb: [
        { text: 'Trader', active: false },
        { text: 'İndikatörler', active: true },
      ],
      resource: 'indicators.list',
      action: 'read',
    },
  },
]
